// import axios from 'more-request/instance';
import axios from 'axios';
import request from '../request';
import { url, baseOssUrl } from '../urlConfig';

const base = 'purchase';
const server = {
  // 查询省列表
  queryProvinceList(params) {
    return request.fetch(
      `/product/salesScope/queryAreaConfig4Province`,
      params
    );
  },
  // 采购计划 需求计划的选择商品
  queryProductPage2(params) {
    return request.post(`/product/mall/queryProductPage`, params);
  },
  // 采购计划 需求计划的选择商品
  queryProductPage(params) {
    return request.post(`/product/mall/queryProductPage`, params);
  },

  //  采购需求列表 - 查询采购需求
  queryPurchaseDemand(params) {
    return request.post(`/${base}/purchaseDemand/queryPurchaseDemand`, params);
  },

  // 修改采购需求
  updatePurchaseDemand(params) {
    return request.post(`/${base}/purchaseDemand/updatePurchaseDemand`, params);
  },

  // 删除采购需求
  deletePurchaseDemand(params) {
    return request.post(`/${base}/purchaseDemand/deletePurchaseDemand`, params);
  },
  // 提交采购需求
  commitPurchaseDemand(params) {
    return request.post(`/${base}/purchaseDemand/commitPurchaseDemand`, params);
  },

  // 创建采购需求
  addPurchaseDemand(params) {
    return request.post(`/${base}/purchaseDemand/addPurchaseDemand`, params);
  },

  // 获取末级小类
  selectCategoryUnitList(params) {
    return request.post('/product/category/selectCategoryUnitList', params);
  },

  // 采购需求审批 - 采购需求审批
  approvePurchaseDemandAa(params) {
    return request.post(`/${base}/purchaseAudit/approvePurchaseDemand`, params);
  },

  // 采购需求审批列表 - 采购需求审批列表
  queryPurchaseDemandApprove(params) {
    return request.post(
      `/${base}/purchaseDemand/queryPurchaseDemandApprove`,
      params
    );
  },

  // 当前部门可用预算列表 - 仅需传orgId/purchaseDemandItem/choosePurchaseDemandProduct
  // 当前部门可用预算列表
  getBudgetListByOrgId(params) {
    return request.post(`/${base}/budget/getBudgetListByOrgId`, params);
  },
  // 采购需求审批记录-采购需求审批记录
  businessAuditLogPage(params) {
    return request.post(`/${base}/businessAuditLog/page`, params);
  },

  //  批量导入采购需求物料 附件上传
  purchaseDemandFile(params) {
    return request.post('/purchase/upload/purchaseDemand', params);
  },

  //  批量导入采购需求物料 下载
  purchaseFileDownload(params) {
    return request.post('/purchase/purchaseDemandItem/excelDownload', params, {
      responseType: 'blob',
    });
  },

  // 计划
  excelDownload(params) {
    return request.post('/purchase/purchasePlan/excelDownload', params, {
      responseType: 'blob',
    });
  },

  // 审批流详情
  approveDetail(params) {
    return request.post('/purchase/audit/detail', params);
  },

  // 采购需求获取审批流
  approveList(params) {
    return request.post('/purchase/audit/list', params);
  },

  // 批量导入采购需求物料
  excelUpload(params) {
    return request.post('/purchase/purchaseDemandItem/excelUpload', params);
  },

  // 查询采购需求跟踪
  logQueryList(params) {
    return request.post('/purchase/purchaseTrackLog/queryList', params);
  },

  // 判断审批流开关
  queryOderConfig(params) {
    return request.post('/user-center/companyConfig/queryOrderConfig', params);
  },

  // 需求执行 选中商品 列表接口
  choosePurchaseDemandItemPc(params) {
    return request.post(
      '/purchase/purchaseDemandItem/choosePurchaseDemandItem',
      params
    );
  },

  // 采购需求物料列表 - 查询所有物料列表
  queryPurchaseDemandItemPc(params) {
    return request.post(
      '/purchase/purchaseDemandItem/queryPurchaseDemandItem',
      params
    );
  },

  // 查询采购需求跟踪列表接口
  queryPurchaseDemandLogPage(params) {
    return request.post(
      '/purchase/purchaseTrackLog/queryPurchaseDemandLogPage',
      params
    );
  },

  // 选中商品展示接口
  queryPurchaseDemandSelectPc(params) {
    return request.post(
      '/purchase/purchaseDemandItem/queryPurchaseDemandSelected',
      params
    );
  },

  // 选中商品展示接口
  choosePurchaseDemandProductPc(params) {
    return request.post(
      '/purchase/purchaseDemandItem/choosePurchaseDemandProduct',
      params
    );
  },

  // 修改数量
  queryPurchaseNumPc(params) {
    return request.post(
      '/purchase/purchaseDemandItem/updatePurchaseDemandSkuCount',
      params
    );
  },

  // 删除需求池商品
  deletePurchaseDemandItemPc(params) {
    return request.post(
      '/purchase/purchaseDemandItem/choosePurchaseDemandItem',
      params
    );
  },

  // 采购需求物料列表 - 选品下单列表
  deletePurchaseDemandItemSkuSelected(params) {
    return request.post(
      '/purchase/purchaseDemandItem/deletePurchaseDemandItemSkuSelected',
      params
    );
  },

  backPurchaseDemand(params) {
    return request.post('/purchase/purchaseDemand/backPurchaseDemand', params);
  },

  terminate(params) {
    return request.post('/purchase/purchasePlan/terminate', params);
  },

  back(params) {
    return request.post('/purchase/purchasePlan/back', params);
  },
  requireFileUrl() {
    return `${url.base}/purchase/upload/purchaseDemand`;
  },
  // 获取阶梯价
  getStepPrice(params) {
    return request.post(`/product/stepPrice/queryBatchStepPrice`, params);
  },
  getProductRate(params) {
    return request.fetch(
      `/product/taxrateManagement/queryTaxrateInfoById`,
      params
    );
  },
  // 采购商-框架协议分页列表查询
  queryAgreementForPurchaseByPage(params) {
    return request.post(
      `/product/agreement/queryAgreementForPurchaseByPage`,
      params
    );
  },
  // 新增接口   返回 采购专属商城用户菜单list
  purchaseMenuList(params) {
    return request.post(`/ubm/purchaseAreaSystem/menuList`, params);
  },
  // 计划接口
  // 获取预算详情
  getBudgetDetailById(params) {
    return request.post(`/${base}/budget/budgetDetail"`, params);
  },

  // 获取组织机构树
  getSelectTreeHasStop(params) {
    return request.post(`/ubm/organization/selectTreeHasStop`, params);
  },
  // 采购需求物料列表-选品下单列表
  queryPurchaseDemandSelected(params) {
    return request.post(
      `/transaction-center/purchaseDemandItem/queryPurchaseDemandSelected`,
      params
    );
  },
  // 采购需求审批列表 - 采购需求审批列表
  queryPurchaseDemandApproveRecord(params) {
    return request.post(
      `/transaction-center/purchaseDemand/queryPurchaseDemandApproveRecord`,
      params
    );
  },

  // 需求池选择商品
  choosePurchaseDemandProduct(params) {
    return request.post(
      `/transaction-center/purchaseDemandItem/choosePurchaseDemandProduct`,
      params
    );
  },
  // 删除需求池商品
  deletePurchaseDemandItem(params) {
    return request.post(
      `/transaction-center/purchaseDemandItem/choosePurchaseDemandItem`,
      params
    );
  },

  // 查询需求池是否有选中的需求单
  queryPurchaseDemandSelectedCount(params) {
    return request.post(
      `/transaction-center/purchaseDemandItem/countPurchaseDemandSelected`,
      params
    );
  },
  // 资源池下单采购数量
  queryPurchaseNum(params) {
    return request.post(
      `/transaction-center/purchaseDemandItem/updatePurchaseDemandSkuCount`,
      params
    );
  },
  //  审批采购计划
  approvePurchasePlan(params) {
    return request.post(`/purchase/purchaseAudit/approvePurchasePlan`, params);
  },

  //  审批采购计划
  queryPurchaseDemandPlanItem(params) {
    return request.post(
      `/purchase/purchaseDemandItem/queryPurchaseDemandPlanItem`,
      params
    );
  },

  // 导出需求计划跟踪概要
  exportDemandTrackLogSummary(params) {
    return request.post(
      `/purchase/purchaseTrackLog/exportDemandTrackLogSummary`,
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 导出需求计划跟踪详情
  exportDemandTrackLogDetail(params) {
    return request.post(
      `/purchase/purchaseTrackLog/exportDemandTrackLogDetail`,
      params,
      {
        responseType: 'blob',
      }
    );
  },

  // 导出采购计划跟踪概要
  exporPlanTrackLogSummary(params) {
    return request.post(
      `/purchase/purchaseTrackLog/exporPlanTrackLogSummary`,
      params,
      {
        responseType: 'blob',
      }
    );
  },

  // 导出采购计划跟踪详情
  exportPlanTrackLogDetail(params) {
    return request.post(
      `/purchase/purchaseTrackLog/exportPlanTrackLogDetail`,
      params,
      {
        responseType: 'blob',
      }
    );
  },

  // 查询采购计划列表-分页查询
  purchasePlanQueryList(params) {
    return request.post(`/purchase/purchasePlan/queryList`, params);
  },
  queryPurchaseDemandItemForPlan(params) {
    return request.post(
      `/purchase/purchaseDemandItem/queryPurchaseDemandItemForPlan`,
      params
    );
  },

  // 修改采购计划
  purchasePlanUpdate(params) {
    return request.post(`/purchase/purchasePlan/update`, params);
  },

  // 提交审批
  purchasePlanSubmit(params) {
    return request.post(`/purchase/purchasePlan/submit`, params);
  },

  // 创建采购计划
  addPurchasePlan(params) {
    return request.post(`/purchase/purchasePlan/add`, params);
  },
  // 查询采购计划详情
  queryPurchaseDemandDetail(params) {
    return request.post(
      `/purchase/purchaseDemand/queryPurchaseDemandDetail`,
      params
    );
  },
  // 解析采购计划物料文件
  purchasePlanParseExcel(params) {
    return request.post(`/purchase/purchasePlan/parseExcel`, params, {
      responseType: 'blob',
    });
  },
  // 选品下单删除物料
  deletePurchasePlanItem(params) {
    return request.post(
      `/purchase/purchasePlan/deletePurchasePlanItem`,
      params
    );
  },
  // 采购计划执行列表
  purchasePlanExecutePage(params) {
    return request.post(`/purchase/purchasePlan/planExecutePage`, params);
  },

  // 选品下单框架协议——执行
  purchasePlanPlanExecute(params) {
    return request.post(`/purchase/purchasePlan/planExecute`, params);
  },
  // 采购计划跟踪
  purchasePlanTrack(params) {
    return request.post(`/purchase/purchasePlan/planTrack`, params);
  },
  // 采购计划详情
  purchaseQueryDetail(params) {
    return request.post(`/purchase/purchasePlan/queryDetail`, params);
  },
  // 协议商品信息
  queryEpecPriceByPage(params) {
    return request.post(`/product/agreement/queryEpecPriceByPage`, params);
  },
  // 查询待审批任务数量
  queryCountWaitApprove(params) {
    return request.post(
      `/purchase/businessAudit/queryCountWaitApprove`,
      params
    );
  },
  // 采购计划任务统计
  purchasePlanStatistical(params) {
    return request.post(
      `/purchase/purchaseStatistical/purchasePlanStatistical`,
      params
    );
  },
  // 采购商框架协议详情
  queryAgreementInfoById(params) {
    return request.fetch(`/product/agreement/queryAgreementInfoById`, params);
  },
  // 查询物料类别列表不分页
  queryAgreementCategoryById(params) {
    return request.fetch(
      `/product/agreement/queryAgreementCategoryById`,
      params
    );
  },
  // 委托招标-完成
  biddingFinish(params) {
    return request.post(`/purchase/purchasePlan/biddingFinish`, params);
  },
  // 计划
  queryPurchaseDemandItemDetail(params) {
    return request.post(
      `/purchase/purchaseDemandItem/queryPurchaseDemandItemDetail`,
      params
    );
  },
  purchasePlanDelete(params) {
    return request.post(`/purchase/purchasePlan/delete`, params);
  },
  // 采购计划选择商品的详情
  queryPurchasePlanItemDetail(params) {
    return request.post(
      `/purchase/purchasePlan/queryPurchasePlanItemDetail`,
      params
    );
  },
  //
  purchaseAreaRecommendCategory: (params) => {
    return axios.get(
      `${baseOssUrl}` +
        'productFile/purchaseAreaRecommendCategory/recommendCategory.json',
      { params: { v: new Date().getTime() } }
    );
  },
  checkPlanItemSku: (params) => {
    return request.post(`/purchase/purchasePlan/checkPlanItemSku`, params);
  },
  // 查询采购申请列表
  queryPurchaseRequestList: (params) => {
    return request.post(
      `/transaction-center/purchaseRequest/queryPurchaseRequestList`,
      params
    );
  },
  // 查询采购计划列表  融合 中化或者盐湖
  queryProcurementPlan: (params) => {
    return request.post(
      `/transaction-center/procurementPlanApplication/queryProcurementPlan`,
      params
    );
  },
  // 查询采购计划列表  融合 中化或者盐湖
  addConversionUnit: (params) => {
    return request.post(
      `/transaction-center/conversionUnit/addConversionUnit`,
      params
    );
  },
  // 删除采购申请  融合 中化或者盐湖
  deleteProcurementPlanRequest: (params) => {
    return request.post(
      `/transaction-center/procurementPlanApplication/deletePurchaseRequest`,
      params
    );
  },
  // 采购申请修改数量  融合 中化或者盐湖
  updateProcurementPlanQuantity: (params) => {
    return request.post(
      `/transaction-center/procurementPlanApplication/updatePurchaseRequestQuantity`,
      params
    );
  },
  // 采购申请选中或取消选中单品返回总价  融合 中化或者盐湖
  checkPurchasePlanRequest: (params) => {
    return request.post(
      `/transaction-center/procurementPlanApplication/checkPurchaseRequest`,
      params
    );
  },
  // 商品选中  融合 中化或者盐湖
  selectPurchasePlanProduct: (params) => {
    return request.post(
      `/transaction-center/procurementPlanApplication/selectProduct`,
      params
    );
  },
  // 查询采购申请详情  融合 中化或者盐湖
  queryProcurementPlanDetail: (params) => {
    return request.fetch(
      `/transaction-center/procurementPlanApplication/queryProcurementPlanDetail`,
      params
    );
  },
  // 查询采购申请详情
  queryPurchaseRequestDetail: (params) => {
    return request.fetch(
      `/transaction-center/purchaseRequest/queryPurchaseRequestDetail`,
      params
    );
  },
  // 商品选中
  selectProduct: (params) => {
    return request.post(
      `/transaction-center/purchaseRequest/selectProduct`,
      params
    );
  },
  //
  checkPurchaseRequest: (params) => {
    return request.post(
      `/transaction-center/purchaseRequest/checkPurchaseRequest`,
      params
    );
  },
  purchaseAreaCategory: (params) => {
    return axios.get(
      `${baseOssUrl}productFile/purchaseAreaCategory/${params.companyId}.json`,
      {
        params: { v: new Date().getTime() },
      }
    );
  },
  getProtocolNo: (params) => {
    return request.fetch(`/product/agreement/queryAgreementCode`, params);
  },
  terminatePurchaseDemand: (params) => {
    return request.post(
      `/purchase/purchaseDemand/terminatePurchaseDemand`,
      params
    );
  },
  // 采购计划回退接口-采购计划回退 中化或者盐湖
  cancelProcurementPlan: (params) => {
    return request.post(`/transaction-center/procurementPlan/cancel`, params);
  },
  // 查看企业类目开关状态：0-关闭，1-开启
  purchaseCategorySwitch: (params) => {
    return request.post(`/product/purchaseCategory/switch`, params);
  },
  // 改变企业类目开关状态：0-关闭，1-开启
  purchaseCategoryChangeSwitch: (params) => {
    return request.post(`/product/purchaseCategory/changeSwitch`, params);
  },
  // 获取企业类目树
  queryPurchaseCategoryTree: (params) => {
    return request.post(`/product/purchaseCategory/categoryTree`, params);
  },
  // 增加分类
  purchaseAddCategory: (params) => {
    return request.post(`/product/purchaseCategory/addCategory`, params);
  },
  // 修改分类
  purchaseModifyCategory: (params) => {
    return request.post(`/product/purchaseCategory/modifyCategory`, params);
  },
  // 分类删除
  purchaseRemoveCategory: (params) => {
    return request.post(`/product/purchaseCategory/removeCategory`, params);
  },
  // 分类删除 全部删除
  purchaseRemoveAll: (params) => {
    return request.post(`/product/purchaseCategory/removeAll`, params);
  },
  // 分类上移
  purchaseCategoryMoveUp: (params) => {
    return request.post(`/product/purchaseCategory/moveUp`, params);
  },
  // 分类下移
  purchaseCategoryMoveDown: (params) => {
    return request.post(`/product/purchaseCategory/moveDown`, params);
  },
  // 查询关联的易派客分类
  purchaseCategoryRel: (params) => {
    return request.post(`/product/purchaseCategory/categoryRel`, params);
  },
  // 查询关联的易派客分类 已被关联，不可勾选的易派客分类
  purchaseCategoryExistRel: (params) => {
    return request.post(`/product/purchaseCategory/existRel`, params);
  },

  // 模板下载接口
  categoryDownloadTemplate: (params) => {
    return request.post(`/product/purchaseCategory/downloadTemplate`, params, {
      responseType: 'blob',
    });
  },
  // 批量导入接口
  categoryBatchUpload: (params) => {
    return request.post(`/product/purchaseCategory/batchUpload`, params);
  },
  // 历史导入详情
  categorUploadPage: (params) => {
    return request.post(`/product/purchaseCategory/uploadPage`, params);
  },
  // 查看映射列表-分页
  mdgCategoryPage: (params) => {
    return request.post(`/product/purchaseCategory/mdgCategoryPage`, params);
  },
  // 映射列表导出
  mdgCategoryExport: (params) => {
    return request.post(`/product/purchaseCategory/export`, params, {
      responseType: 'blob',
    });
  },
  // 是否协议 是否 选择已购    专属商品搜索 融合 中化或者盐湖
  queryZoneProductPage: (params) => {
    return request.post(`product/mall/queryZoneProductPage`, params);
  },
  // 采购申请修改数量
  updatePurchaseRequestQuantity: (params) => {
    return request.post(
      `/transaction-center/purchaseRequest/updatePurchaseRequestQuantity`,
      params
    );
  },
  // path: '/product/agreement/queryAgreementCodeByType',
  queryAgreementCodeByType: (params) => {
    return request.fetch(`/product/agreement/queryAgreementCodeByType`, params);
  },
  //份额 新增
  purchaseShareAdd: (params) => {
    return request.post(`/purchase/purchaseShare/add`, params);
  },
  //份额 批量新增
  purchaseShareBatchAdd: (params) => {
    return request.post(`/purchase/purchaseShare/batchAdd`, params);
  },
  //自然周期份额 详情
  naturalShareDetail: (params) => {
    return request.post(`/purchase/purchaseShare/naturalShareDetail`, params);
  },
  //采购份额-详情
  purchaseShareDetail: (params) => {
    return request.post(`/purchase/purchaseShare/detail`, params);
  },
  //采购份额-详情修改
  purchaseShareModify: (params) => {
    return request.post(`/purchase/purchaseShare/modify`, params);
  },
  //采购份额-详情删除
  purchaseShareDel: (params) => {
    return request.post(`/purchase/purchaseShare/delete`, params);
  },
  //采购份额-停用
  purchaseShareDisabled: (params) => {
    return request.post(`/purchase/purchaseShare/disabled`, params);
  },
  //采购份额-启用
  purchaseShareEnabled: (params) => {
    return request.post(`/purchase/purchaseShare/enable`, params);
  },
  //采购份额-列表
  purchaseShareQueryPage: (params) => {
    return request.post(`/purchase/purchaseShare/queryPage`, params);
  },
  //份额变动记录
  purchaseShareConsume: (params) => {
    return request.post(`/purchase/purchaseShareConsume/queryPage`, params);
  },
  //查询公司所在的集团树
  queryCurrentGroup: (params) => {
    return request.post(`/user-center/companyHierarchy/queryCurrentGroup`, params);
  },
  //是否在集团中，返回true或false
  isInGroup: (params) => {
    return request.post(`/user-center/companyHierarchy/isInGroup`, params);
  },
  //非集团架构  是否易派客2.0的管理员，如果包含采购商管理员、供应商管理员的任意一个，返回 true
  isAdmin: (params) => {
    return request.post(`/ubm/member/isAdmin`, params);
  },
  //集团架构  是否易派客2.0的管理员，如果包含采购商管理员、供应商管理员的任意一个，返回 true 入参{"companyId":‘’}
  isCompanyAdmin: (params) => {
    return request.post(`/ubm/member/isCompanyAdmin`, params);
  },
  //当前公司是否在集团中，是否是根节点，是否是根节点管理员，是否是管理员
  groupJudge: (params) => {
    return request.post(`/user-center/companyHierarchy/groupJudge`, params);
  },



};

export default server;
